<template>
  <el-dialog title="添加商品" width="70%" v-model="visible">

    <el-input v-model="query" placeholder="请输入商品名称" style="width:300px" clearable />
    <el-button type="primary" @click="fetch">查询</el-button>


    <el-table ref="tableRef" :data="list" @selection-change="sel = $event" border style="margin-top:10px">
      <el-table-column type="selection" width="50" />
      <el-table-column prop="spuCode" label="商品编码" />
      <el-table-column prop="spuName" label="商品名称" />
      <el-table-column prop="stockNum" label="库存" />
    </el-table>

    <template #footer>
      <el-button @click="visible=false">取消</el-button>
      <el-button type="primary" @click="confirm">确定</el-button>
    </template>
  </el-dialog>
</template>

<script setup lang="ts">
import { ref, watch, nextTick } from 'vue'
import {  useCurrentAppInstance } from '@zto/zpage'

// queryGroundingSpuInfoWithoutCat
const app = useCurrentAppInstance()

const props = withDefaults(
  defineProps<{
    visible:boolean,
    withoutCat: boolean,
    selectedCodes?: string[]
  }>(),
  {
    visible: false,
    withoutCat:false,
    selectedCodes: () => []
  }
)



const emit = defineEmits(['update:visible','confirm'])
const visible = ref(props.visible)
const tableRef = ref()

const query = ref('')
const page = ref(1)
const total = ref(100)
const list = ref<any[]>([])
const sel = ref<any[]>([])

const syncSelection = () => {
  nextTick(() => {
    if (!tableRef.value || !list.value) return
    tableRef.value.clearSelection()
    if (!props.selectedCodes || props.selectedCodes.length === 0) return

    const selectedSet = new Set(props.selectedCodes)
    list.value.forEach(row => {
      if (selectedSet.has(row.spuCode)) {
        tableRef.value.toggleRowSelection(row, true)
      }
    })
  })
}

watch(() => props.visible, v => {
  visible.value = v
  if (v) {
    syncSelection()
  }
})
watch(visible, v => emit('update:visible', v))
watch(list, () => {
  if (visible.value) {
    syncSelection()
  }
})

const fetch = async () => {
  let apiUrl = 'admin/goods/querySpuInfoList'
  if (props.withoutCat){
    apiUrl = 'admin/goods/queryGroundingSpuInfoWithoutCat'
  }
  const resp = await app.request({
    api: apiUrl,
    params: {
      pageSize: 10000,
      pageIndex: 1,
      spuName: query.value || undefined // ⭐ 商品名称查询
    }
  })
  list.value = resp?.filter((item)=>item.goodsStatus !== 'off_shelf')
}

const confirm = () => {
  emit('confirm', sel.value)
  visible.value = false
}

fetch()
</script>
